
import type { CirclePackChart, HighlightedCircle } from '../shared/types.js';

export let chartInstance: CirclePackChart | null = null;
export const highlightedCircles: HighlightedCircle[] = [];
export const highlightedNodeNames: Set<string> = new Set();
export const exactMatchNodeNames: Set<string> = new Set();
export let currentSearchTerm = '';
export const contentHighlightedCircles: HighlightedCircle[] = [];
export let showContentNodesActive = false;
export let showMyRolesActive = false;
export let skipNextPanelUpdate = false;

// Chart refresh callback
export let refreshChartCallback: (() => Promise<void>) | null = null;

// Click timer cancellation callback
export let cancelClickTimerCallback: (() => void) | null = null;

// Last purpose value for change detection
export let lastPurposeValue = '';

// Leaf claim cache for role claim status
export const leafClaimCache: Record<string, boolean> = {};

// Role map for looking up current role names by ID (to handle renamed roles in references)
export const roleMap: Map<number, string> = new Map();

export function setChartInstance(instance: CirclePackChart | null): void {
    chartInstance = instance;
}

export function setRefreshChartCallback(callback: (() => Promise<void>) | null): void {
    refreshChartCallback = callback;
}

export function setCancelClickTimerCallback(callback: (() => void) | null): void {
    cancelClickTimerCallback = callback;
}

export function setLastPurposeValue(value: string): void {
    lastPurposeValue = value;
}

export function setSearchTerm(term: string): void {
    currentSearchTerm = term;
}

export function setShowContentNodesActive(flag: boolean): void {
    showContentNodesActive = flag;
}

export function setShowMyRolesActive(flag: boolean): void {
    showMyRolesActive = flag;
}

export function setSkipNextPanelUpdate(flag: boolean): void {
    skipNextPanelUpdate = flag;
}

export function resetHighlights(): void {
    highlightedCircles.length = 0;
    highlightedNodeNames.clear();
    exactMatchNodeNames.clear();
}
